import { NgModule, Component } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomepageComponent } from './homepage/homepage.component';
import { MenuComponent } from './menu/menu.component';
import { AboutComponent } from './about/about.component';
import { CareerComponent } from './career/career.component';
import { ContactComponent } from './contact/contact.component';
import { ProductListsComponent } from './products/product-lists/product-lists.component';
import{SubcatsComponent} from './products/subcats/subcats.component';
import {ProductDetailsComponent} from './products/product-details/product-details.component';
import { LoginComponent} from './userpages/login/login.component'; 
import { RegisterComponent} from './userpages/register/register.component'; 
import { ForgotPasswordComponent} from './userpages/forgot-password/forgot-password.component'; 
import { CartComponent} from './cart/cart.component'; 
import { MyaccountComponent} from './my-account/myaccount/myaccount.component'; 
import { EditprofileComponent} from './my-account/editprofile/editprofile.component'; 
import { ChangepasswordComponent} from './my-account/changepassword/changepassword.component'; 
import { UserForgotpasswordComponent} from './my-account/user-forgotpassword/user-forgotpassword.component'; 
import { VerifyregisterComponent } from './userpages/verifyregister/verifyregister.component';
import { MyaddressesComponent } from './my-account/myaddresses/myaddresses.component';
import { OrdersComponent } from './my-account/orders/orders.component';
import { OrderDetailsComponent } from './my-account/order-details/order-details.component';
import { TrackOrderComponent } from './my-account/track-order/track-order.component';
import { EditAddressComponent } from './my-account/edit-address/edit-address.component';
import { CheckoutComponent } from './checkout/checkout.component';
import {AddAddressComponent} from './my-account/add-address/add-address.component';
import {ProductSearchComponent} from './products/product-search/product-search.component';
import { ThankYouComponent } from './thank-you/thank-you.component';
import { ResetPasswordComponent} from './userpages/reset-password/reset-password.component'; 
import { PaymentCancelComponent} from './payment-cancel/payment-cancel.component'; 
import { OngoingOrdersComponent} from './my-account/ongoing-orders/ongoing-orders.component';
import {OrderTrackComponent} from './order-track/order-track.component';
import { OtherpageComponent } from './otherpages/otherpage/otherpage.component';
import { RewardpointsComponent } from './my-account/rewardpoints/rewardpoints.component';
import { WishlistComponent } from './my-account/wishlist/wishlist.component';
import { SavedCardsComponent } from './my-account/saved-cards/saved-cards.component';
import { ResFormComponent } from './res-form/res-form.component';
import { ShishaComponent } from './shisha/shisha.component'; 
import { GuestCheckoutComponent } from './guest-checkout/guest-checkout.component';

const routes: Routes = [
  {path: '', component: HomepageComponent},
  {path: 'menu' , component: MenuComponent},
  {path: 'about' , component: AboutComponent},
  {path: 'career' , component: CareerComponent},
  {path: 'contact' , component: ContactComponent},
  {path: 'order-online/cats/:catslug' , component: ProductListsComponent},
  {path: 'order-online/subcats/:catslug' , component: SubcatsComponent},
  {path: 'order-online' , component: ProductListsComponent},
  {path:'product/:catslug/:pslug', component:ProductDetailsComponent},
  {path: 'login' , component: LoginComponent},
  {path: 'register' , component: RegisterComponent},
  {path: 'register-verify' , component: VerifyregisterComponent},
  {path: 'forgot-password' , component: ForgotPasswordComponent},
  {path: 'cart' , component: CartComponent},
  {path: 'my-account' , component: MyaccountComponent, data:{heading:'My Account', heading_ar:'حسابي'}},
  {path: 'my-account/editprofile' , component: EditprofileComponent, data:{heading:'Edit Profile', heading_ar:'تعديل الملف الشخصي'}},
  {path: 'my-account/change-password' , component: ChangepasswordComponent},
  {path: 'my-account/forgotpassword' , component: UserForgotpasswordComponent},
  {path: 'my-account/myaddresses' , component: MyaddressesComponent, data:{heading:'My Addresses', heading_ar:'عناويني'}},
  {path: 'my-account/editaddress/:addressid' , component: EditAddressComponent, data:{heading:'Edit Address', heading_ar:'تعديل العنوان'}},
  {path: 'my-account/add-address' , component: AddAddressComponent, data:{heading:'Add Address',heading_ar:'اضف عنوان' }},
  {path: 'my-account/orders' , component: OrdersComponent, data:{heading:'My Orders', heading_ar:'طلباتي'}},
  {path: 'my-account/order-details/:ordid' , component: OrderDetailsComponent, data:{heading:'Order Detail', heading_ar:'تفاصيل الطلب'}},
  {path: 'my-account/track-order/:ordid' , component: TrackOrderComponent, data:{heading:'Track Order', heading_ar:'ترتيب المسار'}},
  {path: 'my-account/saved-cards' , component: SavedCardsComponent, data:{heading:'Saved Cards', heading_ar:'البطاقات المحفوظة'}},
  {path: 'order-track/:ordid' , component: OrderTrackComponent, data:{heading:'Track Order', heading_ar:'ترتيب المسار' }},
  {path: 'search' , component: ProductSearchComponent},
  {path: 'checkout' , component: CheckoutComponent},
  {path: 'thank-you' , component: ThankYouComponent},
  {path: 'reset-password' , component: ResetPasswordComponent},
  {path: 'payment-cancelled' , component: PaymentCancelComponent},
  {path: 'my-account/ongoing-orders' , component: OngoingOrdersComponent, data:{heading:'Ongoing Orders', heading_ar:'الطلبات الجارية' }},
  {path: 'page/:slug' , component: OtherpageComponent},
  {path: 'my-account/loyalty-account' , component: RewardpointsComponent, data:{heading:'Loyalty Account', heading_ar:'حساب الولاء'}},
  {path: 'my-account/my-wishlist' , component: WishlistComponent, data:{heading:'My Favorites', heading_ar:'مفضلتي'}},
  {path: 'reserve' , component: ResFormComponent},
  {path: 'shisha' , component: ShishaComponent},
  {path: 'guest-checkout' , component: GuestCheckoutComponent},
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {

 }


